import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import AttendenceObjectiveComponent from './AttendenceObjectiveComponent';

const AttendanceDetails = ({ data }) => {
  //THIS DATA WILL CONTAIN OBJECTIVES AND ALSO ATTENDENCE DATA ARRAY

  const objectIntoArray = Object.entries(data); //MAKING IT AS AN ITERABLE ARRAY FROM THIS OBJECT
  const alwaysShow = ['totalP', 'totalA', 'totalWO'];
  const needToBeRemoveObjects = [
    'attendance',
    'verification',
    'verification_by',
    'attendanceId',
    'payableDays',
    'joinDate',
    'exitDate'
  ];
  
  const removedAttendenceArray = objectIntoArray.filter(([key, value]) => {
    if (needToBeRemoveObjects.includes(key)) return false;
    if (value === 0 && !alwaysShow.includes(key)) return false;
    return true;
  });

  const iterableArray = removedAttendenceArray.map(([key, value]) => ({
    //NO NEED OF ATTENDANCE DATA AS KEY VALUE PAIRS SO REMOVED IT
    objectiveName: key,
    value: value,
  }));

  return (
    <Paper elevation={3}>
      <Box sx={{ padding: 2 }}>
        {/* ANOTHER METHOD TO AVOID REPEATED CALLING OF COMPONENT*/}
        {iterableArray.map((objective) => {
          let color = '';
          let name = '';
          if (objective.objectiveName === 'totalA' || objective.objectiveName === 'totalLWP') {
            color = '#ffe4de';
            if (objective.objectiveName === 'totalA') {
              name = 'Total Absent';
            } else if (objective.objectiveName === 'totalLWP') {
              name = 'Total LOP';
            }
          } else if (
            objective.objectiveName === 'totalP' ||
            objective.objectiveName === 'totalWFH' ||
            objective.objectiveName === 'totalOD'
          ) {
            color = '#c8facd';
            if (objective.objectiveName === 'totalP') {
              name = 'Total Present';
            } else if (objective.objectiveName === 'totalOD') {
              name = 'Total On Duty';
            } else if (objective.objectiveName === 'totalWFH') {
              color = '#78d6ceff';
              name = 'Total Work From Home';
            }
          } else if (
            objective.objectiveName === 'totalHD' ||
            objective.objectiveName === 'totalWO' ||
            objective.objectiveName === 'totalCO'
          ) {
            color = '#bbd1e4cf';
            if (objective.objectiveName === 'totalHD') {
              name = 'Total Holiday';
            } else if (objective.objectiveName === 'totalWO') {
              name = 'Total Week Off';
            } else if (objective.objectiveName === 'totalCO') {
              name = 'Total Compensatory';
            }
          } else if (
            objective.objectiveName === 'totalCL' ||
            objective.objectiveName === 'totalSL' ||
            objective.objectiveName === 'totalML' ||
            objective.objectiveName === 'totalPL' ||
            objective.objectiveName === 'totalPrivilegeLeave' ||
            objective.objectiveName === 'totalDot' ||
            objective.objectiveName === 'totalEL'
          ) {
            color = '#dccfe0';
            if (objective.objectiveName === 'totalCL') {
              name = 'Total Casual Leave';
            } else if (objective.objectiveName === 'totalDot') {
              name = 'Total Dot Leave';
            } else if (objective.objectiveName === 'totalSL') {
              name = 'Total Sick Leave';
            } else if (objective.objectiveName === 'totalML') {
              name = 'Total Maternity Leave';
            } else if (objective.objectiveName === 'totalPL') {
              name = 'Total Paid Leave';
            } else if (objective.objectiveName === 'totalPrivilegeLeave') {
              name = 'Total Privilege Leave';
            } else if (objective.objectiveName === 'totalEL') {
              name = 'Total Earned Leave';
            }
          } else {
            color = '';
            name = objective.objectiveName;
          }
          return (
            <AttendenceObjectiveComponent
              key={objective.objectiveName}
              backgroundColor={color}
              objectiveName={name}
              values={objective.value}
            />
          );
        })}

        <Box sx={{ mt: 3, p: 1.5, bgcolor: '#f0f4f8', borderRadius: 2, border: '1px solid #cddc39' }}>
          <Typography variant="subtitle1" fontWeight="bold" color="primary">
            Payable Days : {data.payableDays}
          </Typography>
        </Box>

        {(data.joinDate || data.exitDate) && (
          <Box sx={{ mt: 2, borderTop: '1px solid #eee', pt: 1 }}>
            {data.joinDate && (
              <Typography variant="body2" color="textSecondary">
                <strong>Join Date:</strong> {new Date(data.joinDate).toLocaleDateString()}
              </Typography>
            )}
            {data.exitDate && (
              <Typography variant="body2" color="textSecondary">
                <strong>Exit Date:</strong> {new Date(data.exitDate).toLocaleDateString()}
              </Typography>
            )}
          </Box>
        )}

        {/* <AttendenceObjectiveComponent backgroundColor={"#c8facd"} objectiveName={"Total Present"} value={data.totalP}/>
        <AttendenceObjectiveComponent backgroundColor={"#ffe4de"} objectiveName={"Total Absent"} value={data.totalA}/>
        <AttendenceObjectiveComponent backgroundColor={"#ffe4de"} objectiveName={"Total Loss Of Pay"} value={data.totalLWP}/>
        <AttendenceObjectiveComponent backgroundColor={"#bbd1e4cf"} objectiveName={"Total Holiday"} value={data.totalHD}/>
        <AttendenceObjectiveComponent backgroundColor={"#bbd1e4cf"} objectiveName={"Total WeekOff"} value={data.totalWO}/>
        <AttendenceObjectiveComponent backgroundColor={"#bbd1e4cf"} objectiveName={"Total Compensatory"} value={data.totalCO}/>
        <AttendenceObjectiveComponent backgroundColor={"#dccfe0"} objectiveName={"Total Casual Leave"} value={data.totalCL}/>
        <AttendenceObjectiveComponent backgroundColor={"#dccfe0"} objectiveName={"Total Sick Leave"} value={data.totalSL}/>
        <AttendenceObjectiveComponent backgroundColor={"#dccfe0"} objectiveName={"Total Medical Leave"} value={data.totalML}/>
        <AttendenceObjectiveComponent backgroundColor={"#dccfe0"} objectiveName={"Total Paid Leave"} value={data.totalPL}/>
        <AttendenceObjectiveComponent backgroundColor={""} objectiveName={"Payable Days"} value={data.payableDays}/> */}
      </Box>
    </Paper>
  );
};

export default AttendanceDetails;
